import type {
  AssessmentsAccumulationMappingsResponse,
  AssessmentsAccumulationResponse,
} from '@/entities/assessments/api/generated/model';

export type DefaultAccumulationTableRowData = {
  id: string;
  base: {
    id: string;
    name: string;
    amount: number;
  } | null;
  compared: {
    id: string;
    name: string;
    amount: number;
  } | null;
};

/**
 * 積算明細データをテーブル表示用に変換
 *
 * 積算明細（bases/compareds）を抽出し、
 * 項目名ごとにマージして表示用のデータ構造に変換
 *
 * @param accumulationData - 積算明細データ
 * @returns テーブル表示用の行データ配列
 */
export const formatDefaultAccumulationsTableData = (
  accumulationData: AssessmentsAccumulationResponse | AssessmentsAccumulationMappingsResponse,
): DefaultAccumulationTableRowData[] => {
  const { bases, compareds } = accumulationData;
  const baseLength = bases.length;
  const comparedLength = compareds.length;

  const overBaseLength = baseLength > comparedLength;

  if (overBaseLength) {
    return bases.map<DefaultAccumulationTableRowData>((base, index) => {
      const compared = compareds[index];
      const id = [base.id, compared?.id, index].filter(Boolean).join('-');
      return {
        id: id,
        base: {
          id: base.id,
          name: base.description,
          amount: base.amount,
        },
        compared: compared
          ? {
              id: compared.id,
              name: compared.description,
              amount: compared.amount,
            }
          : null,
      };
    });
  }

  return compareds.map((compared, index) => {
    const base = bases[index];
    const id = [base?.id, compared.id, index].filter(Boolean).join('-');
    return {
      id: id,
      base: base
        ? {
            id: base.id,
            name: base.description,
            amount: base.amount,
          }
        : null,
      compared: {
        id: compared.id,
        name: compared.description,
        amount: compared.amount,
      },
    };
  });
};
